import { FC } from "react";
import { IOrder } from "../../../model/IOrder";
import { DetailPanel, DetailTable } from "./DetailPanel";

const stamp = (value: string | null) => {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : `${date.toLocaleDateString('en-CA')} ${date.toLocaleTimeString('en-GB')}`;
};

const OrderReplacements: FC<{ order: IOrder }> = ({ order }) => (
  <DetailPanel title="Warranty / Replacement Shipments">
    <DetailTable
      head={[
        'Product Name', 'Product Id', 'Supplier Product Id', 'Date',
        'Status', 'Invoice', 'Shipper', 'Tracking Number', 'Comments',
      ]}
      empty="No replacement shipments"
    >
      {(order.replacements || []).map((replacement, i) => (
        <tr key={replacement.id ?? i} className="odd:bg-gray-50 align-top">
          <td className="py-2 px-2 font-medium">{replacement.productName || '—'}</td>
          <td className="py-2 px-2 whitespace-nowrap">{replacement.productId || '—'}</td>
          <td className="py-2 px-2 whitespace-nowrap">{replacement.supplierId || '—'}</td>
          <td className="py-2 px-2 whitespace-nowrap">{stamp(replacement.timeCreated)}</td>
          <td className="py-2 px-2 whitespace-nowrap">{replacement.status || '—'}</td>
          <td className="py-2 px-2 whitespace-nowrap">{replacement.invoice || '—'}</td>
          <td className="py-2 px-2 whitespace-nowrap">{replacement.shipper || '—'}</td>
          <td className="py-2 px-2 whitespace-nowrap">{replacement.trackingNumber || '—'}</td>
          <td className="py-2 px-2 max-w-[280px]">{replacement.comments || '—'}</td>
        </tr>
      ))}
    </DetailTable>
  </DetailPanel>
);

export default OrderReplacements;
